import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ReportService } from '../../_services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalDataService } from '../../_shared';
import { EnterVoWD, Supplier, Report, DropAmtComnt, LoginUser, Role , CostCenter} from '../../_models';
import { ModalPopupAlertComponent } from '../../_shared/modal-popup-alert/modal-popup-alert.component';
import * as XLSX from 'xlsx'; 
import { Subscription, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-payment-detail-reports',
  templateUrl: './payment-detail-reports.component.html',
  styleUrls: ['./payment-detail-reports.component.css']
})
export class PaymentDetailReportsComponent implements OnInit {

  ChkAll: any =false;
  ChkOne: any =false;
  config: any;
  rptData = new Report();
  dropAmtComnt = new DropAmtComnt();
  CostCentersResult: CostCenter[] = [];
  SupplierAB!: string | null;
  SupName = ''; 
  DropID=0;
  ObjectAccount = '';  
  ObjectAccountDesr = ''; 
  Area!: string | null;
  Department!: string | null;
  arrayListArea: Array<string> = [];
  arrayListDepartment: Array<string> = [];
  arrayListAreaDistinct: Array<string> = [];
  arrayListDepartmentDistinct: Array<string> = [];
  Year = '';  
  cmd = 'DROP';
  Month='';
  Drop:number=0;
  ExistingDrop:number=0;
  FractionDrop:number[] = [];
  Adjust:number = 0;
  DropComments='';
  Remarks='';
  dropAnalysisResult: any[] = [];
  resVowdList: any[] = [];
  dropAnalysisView = new EnterVoWD();
  suppliersResult: Supplier[] = [];
  objectAccountsResult: string[] = [];
  getMonths: string[] = [];
  getYrs : string[]=[];
  user: LoginUser = new LoginUser;
  flgLock: boolean = false;
  subscription: Subscription = new Subscription;
  DropsAdjumntSum!: number;
  PendingAccural!: number;
  results!: Observable<Supplier[]>;  
  loading: boolean = true;
  private searchTerms = new Subject<string>();  
  resultsObj!: Observable<string[]>; 
  private searchTermsObj = new Subject<string>();  
  FrmDt: any ;
  ToDt: any ;
  ApprDt!: { year: number; month: number; day: number; };
  FromAppDt: any;
  ToAppDt:any;
  arrayList: Array<string> = [];
  @ViewChild('TABLE', { static: false })
  TABLE!: ElementRef;  
  title = 'Excel';  
  errDrop: boolean = false;
  errDropCmt: boolean = false;
  vowdTotal: number=0;
  vowdInv: number=0;
  vowdAdj: number=0;
  vowdDrp: number=0;
  vowdOvp: number=0;
  vowdAccr: number=0;

  constructor(
    private reportService  : ReportService,
    private gd : GlobalDataService,
    private modalService: NgbModal
  ) { }
  
  ExportTOExcel() { 
    var reportGrid = document.getElementById("reportGrid_all");
    var wb: XLSX.WorkBook = XLSX.utils.book_new();
    let ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(reportGrid);
    wb.SheetNames.push("Sheet1");
    wb.Sheets["Sheet1"] = ws;
    XLSX.writeFile(wb, 'Payment_Details' + new Date().toDateString() + '_' + new Date().getTime().toString() + '.xlsx');
  } 

  ngOnInit() {
   
    this.user = this.gd.getUserData();
    this.getSuppliers();
    this.getObjectAccount();
    this.getCenterData();
    this.getMonths = this.gd.monthNames;
    this.Month = this.gd.monthNames[new Date().getMonth()];
    this.getAcurlYr();
    this.GetApprovedDate();
    this.config = {
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: this.dropAnalysisResult.length
    };
  }
  
  GetApprovedDate(){
    this.reportService.getApprovedDate().subscribe(res => {
      if(res!=null)
      {
        this.ApprDt = {
          "year": new Date(res.ApproveDate).getFullYear(),
          "month":  new Date(res.ApproveDate).getMonth()+1,
          "day": new Date(res.ApproveDate).getDate()
        }
      }
    });
  }
  getCenterData()
  {
    this.CostCentersResult= this.gd.getCostCenterData();
    this.arrayListArea = this.CostCentersResult.map(cost => cost.Area_CODE +"-" +cost.Area_description); 
    this.arrayListDepartment = this.CostCentersResult.map(cost =>cost.Division); 
    this.arrayListAreaDistinct = this.arrayListArea.filter((n, i) => this.arrayListArea.indexOf(n) === i);
    this.arrayListDepartmentDistinct = this.arrayListDepartment.filter((n, i) => this.arrayListDepartment.indexOf(n) === i);
  }
  searchArea = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayListAreaDistinct.filter(v => v!=null && v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  searchDepartment = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayListDepartmentDistinct.filter(v => v!=null && v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )
  getSuppliers()
  {
    this.suppliersResult= this.gd.getSupplierData();
    this.arrayList = this.suppliersResult.map(sup => sup.SupplierAB.toString().trim() +"-" +sup.SupplierName.toString().trim()); 
  }

  searchSupplier = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  searchObjectAcnt = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.objectAccountsResult.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  getDropAnanlysis()
  {
     
    if(((this.FrmDt != null && this.FrmDt != undefined) && (this.ToDt !=null && this.ToDt != undefined)) 
      || 
      ((this.FromAppDt != null && this.FromAppDt != undefined) && (this.ToAppDt !=null && this.ToAppDt != undefined)))
    {
      this.PrepareReportData();
      this.SearchDropAnalysisReport();
    }
    else{
      this.openAlertModal("Please select the Service Date or Approved Date range");
    }
  }

    
  SearchDropAnalysisReport()
  {
    this.reportService.getPaymentDetails(this.rptData).subscribe(data=>{
      this.dropAnalysisResult = data;
      for (let i=0;i<this.dropAnalysisResult.length;i++)
      {
        this.dropAnalysisResult[i].ObjDescr = this.objectAccountsResult.filter(t=>t.split('-')[0].trim()== this.dropAnalysisResult[i].ObjectAccount.trim())[0];
        this.dropAnalysisResult[i].ObjDescr = this.dropAnalysisResult[i].ObjDescr != null || this.dropAnalysisResult[i].ObjDescr != undefined ? 
                                              this.dropAnalysisResult[i].ObjDescr : this.dropAnalysisResult[i].ObjectAccount
      }
     
      this.config = {
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: this.dropAnalysisResult.length
      };
      });
      
      this.subscription = this.gd.flgVOWDLock$.subscribe(
        flgVOWDLock => this.flgLock = flgVOWDLock
      );

  }

  PrepareReportData()
  {
    this.rptData.supplierAB=(this.SupplierAB==null || this.SupplierAB.trim()=='')?0: parseInt(this.SupplierAB.split('-')[0]);
    this.rptData.objectAccount=this.ObjectAccount;
    this.rptData.area=(this.Area==null||this.Area=='')? null:this.Area.split('-')[0];
    this.rptData.department=(this.Department==null||this.Department=='')?null:this.Department;
    this.rptData.year =  new Date(this.FrmDt).getFullYear().toString() ;//this.Year;
    this.rptData.FromDate = (this.FrmDt !=null && this.FrmDt !=undefined) ? this.gd.convertToStandardDate(this.FrmDt) : null;
    this.rptData.ToDate = (this.ToDt !=null && this.ToDt != undefined) ? this.gd.convertToStandardDate(this.ToDt) : null;
    this.rptData.FromAppDate = (this.FromAppDt !=null && this.FromAppDt !=undefined) ? this.gd.convertToStandardDate(this.FromAppDt) : null;
    this.rptData.ToAppDate = (this.ToAppDt != null && this.ToAppDt !=undefined) ? this.gd.convertToStandardDate(this.ToAppDt) : null;
    this.rptData.ApprDate = this.gd.convertToStandardDate(this.ApprDt);
  }
   
  onselectSupplier(SupObj :Supplier) {     
    if (SupObj.SupplierAB != 0) {  
      this.SupplierAB = SupObj.SupplierAB.toString();
      this.SupName = SupObj.SupplierName +"-("+ SupObj.SupplierAB +")";  
      this.loading = false; 
      return true; 
    }  
    else {  
      return false;  
    }
  }

  getAcurlYr()
  {
    for (var i = 2000; i <= 2040; i++) {
      this.getYrs.push(i.toString());
    }
    this.Year = new Date().getFullYear().toString();
  }

  getObjectAccount()
  {
    this.objectAccountsResult=this.gd.getAccountData();
  }

   // Push a search term into the observable stream.  
  searchObjAcnt(term: string): void {  
    if(term.length < 2)
    {
    this.getObjectAccount();
    }
      this.loading = true;  
      this.searchTermsObj.next(term); 
  }  
  
 onselectObjAcnt(ObjAcnt :string) {     
   if (ObjAcnt != '') {  
    this.ObjectAccount =ObjAcnt.split('-')[0].toString();
    this.ObjectAccountDesr =ObjAcnt;
     this.loading = false;  
     return true;
   }  
   else {  
     return false;  
   }
 }

 
  
  openAlertModal(strmsg: string) {
    const options ={
      backdrop: false,
      size: 'lg',
      keyboard : false

    };
    setTimeout(()=>{
      const modalRef = this.modalService.open(ModalPopupAlertComponent,options);
      modalRef.componentInstance.strText = strmsg;
      modalRef.result.then((result) => {
      }, (reason) => {
      });   
    });
     
  }
  
  pageChanged(event: any){
    this.config.currentPage = event;
  }
  
  ConvertToInt(val: string){
    return parseFloat(val);
  }

}
